export class ActivityProperty<T> {
  constructor(public key: string, public old: T, public current: T) {}
}
